import React from 'react';
import {Field} from 'formik';
import {
	FormControl,
	FormHelperText,
	InputLabel,
	MenuItem,
	Select,
	TextField,
	Typography
} from "@mui/material";
import CampaignFrequencyField from "./CampaignFrequencyField";
import Grid from "@mui/material/Grid2";
import ClientSelectorV2 from "../../patrimoine/ClientSelectorV2";
import {extractId, toIri} from "../../../../utils/apiResource";


// Heure de début : quarts d'heure uniquement — on ne démarre jamais une
// tournée à « 8h27 ». La valeur reste une chaîne "HH:MM" (sans timezone).
const QUARTER_HOURS = Array.from({length: 24 * 4}, (_, i) => {
	const h = String(Math.floor(i / 4)).padStart(2, '0');
	const m = String((i % 4) * 15).padStart(2, '0');
	return `${h}:${m}`;
});

function CampaignDataField({...props}) {
    const {values, errors, clients, prestations, handleChange, handleBlur, onClientSelected} = props;

    const selectedClient = clients?.find((client) => client['@id'] === values.client);

    const handleClientSelected = (clientIri) => {
        onClientSelected(clientIri)
    }


    return (
        <Grid size={12} container spacing={1} className={"sectionContainer"}>
            <Grid size={12}>
                <Typography variant={"h5"} className={"sectionHeader"}>Informations</Typography>
            </Grid>

            {/*LIBELLE FIELD*/}
            <Grid size={12} container alignItems={"center"}>
                <Grid size={3}>
                    Libellé <span className="asterix">*</span>
                </Grid>
                <Grid size={9}>
                    <Field
                        type="text"
                        value={values.libelle}>
                        {({form}) => (
                            <TextField
                                error={
                                    Boolean(form.errors.libelle && form.touched.libelle)
                                }
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.libelle}
                                variant="outlined"
                                margin="normal"
                                fullWidth
                                name="libelle"
                                label="libelle"
                                autoFocus
                                helperText={
                                    form.errors.libelle &&
                                    form.touched.libelle &&
                                    String(form.errors.libelle)
                                }/>
                        )}
                    </Field>
                </Grid>
            </Grid>

            <CampaignFrequencyField values={values} errors={errors} handleChange={handleChange}
                                    handleBlur={handleBlur}/>

            {/*HEURE DE DEBUT FIELD */}
            <Grid size={12} container alignItems={"center"} className={"mt-2"}>
                <Grid size={3}>
                    Heure de début
                </Grid>
                <Grid size={9}>
                    <FormControl sx={{minWidth: 220}}>
                        <InputLabel id="label-heure-debut">Heure de début</InputLabel>
                        <Select
                            labelId="label-heure-debut"
                            label="Heure de début"
                            variant="outlined"
                            name="heureDebut"
                            value={values.heureDebut || ''}
                            onChange={handleChange}
                        >
                            <MenuItem value=""><em>— Aucune —</em></MenuItem>
                            {QUARTER_HOURS.map((heure) => (
                                <MenuItem key={heure} value={heure}>{heure}</MenuItem>
                            ))}
                        </Select>
                        <FormHelperText>
                           Heure de début affiché sur le téléphone
                        </FormHelperText>
                    </FormControl>
                </Grid>
            </Grid>

            {/*PRESTATION FIELD*/}
            <Grid size={12} container alignItems={"center"} className={"mt-2"}>
                <Grid size={3}>
                    Prestation <span className="asterix">*</span>
                </Grid>
                <Grid size={9}>
                    <Field
                        type="text"
                        name="client"
                        value={values.prestation}>
                        {() => (
                            <FormControl fullWidth error={Boolean(errors.prestation)}>
                                <InputLabel id="label-client">Sélectionner le type de prestation :</InputLabel>
                                <Select
                                    labelId="label-prestation"
                                    label="Sélectionner la prestation :"
                                    variant="outlined"
                                    name="prestation"
                                    value={values.prestation}
                                    onChange={handleChange}
                                >
                                    {prestations && prestations.map((p) => {
                                        return (
                                            <MenuItem key={p.id} value={p["@id"]}>
                                                {p.libelle}
                                            </MenuItem>
                                        )
                                    })}
                                </Select>
                                {errors.prestation &&
                                    String(errors.prestation) &&
                                    <FormHelperText error={true}>{errors.prestation}</FormHelperText>}
                            </FormControl>
                        )
                        }
                    </Field>
                </Grid>
            </Grid>

            {/*CLIENT FIELD*/}
            <Grid size={12} container alignItems={"center"} className={"mt-2"}>
                <Grid size={3}>
                    Client <span className="asterix">*</span>
                </Grid>
                <Grid size={9}>
                    <Field
                        type="text"
                        name="client"
                        value={values.client}>
                        {({form}) => (
                            <>
                                <ClientSelectorV2
                                    clients={clients}
                                    clientSelected={extractId(values.client)}
                                    onClientSelected={(clientId) => {
                                        const nextClient = toIri('clients', clientId);
                                        handleClientSelected(nextClient)
                                        form.setFieldValue('client', nextClient);
                                        form.setFieldValue('formulaire', '');
                                        form.setFieldValue('patrimoine', '');
                                        form.setFieldValue('conteneurs', []);
                                        form.setFieldValue('ordre', []);
                                    }}
                                    label="Sélectionner le client"
                                    inline
                                />
                                {errors.client &&
                                    String(errors.client) &&
                                    <FormHelperText error={true}>{errors.client}</FormHelperText>}
                            </>
                        )
                        }
                    </Field>
                </Grid>
            </Grid>

            {/*FORMS FIELD*/}
            <Grid size={12} container alignItems={"center"} className={"mt-2"}>
                <Grid size={3}>
                    Formulaire à utiliser <span className="asterix">*</span>
                </Grid>
                <Grid size={9}>
                    <Field
                        type="text"
                        name="client"
                        value={values.formulaire}>
                        {() => (
                            <FormControl fullWidth error={Boolean(errors.formulaire)}>
                                <InputLabel id="label-formulaire">Sélectionner le formulaire :</InputLabel>
                                <Select
                                    labelId="label-formulaire"
                                    label="Sélectionner le formulaire :"
                                    variant="outlined"
                                    name="formulaire"
                                    value={values.formulaire}
                                    onChange={handleChange}
                                >

                                    {selectedClient && selectedClient.forms.map((f) => {
                                        return (
                                            <MenuItem key={f.id} value={f["@id"]}>
                                                {f.libelle}
                                            </MenuItem>
                                        )
                                    })}

                                </Select>
                                {errors.formulaire &&
                                    String(errors.formulaire) &&
                                    <FormHelperText error={true}>{errors.formulaire}</FormHelperText>}
                            </FormControl>
                        )
                        }
                    </Field>
                </Grid>
            </Grid>
        </Grid>
    );
}

export default CampaignDataField;
